import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { CompanyEmailSettings } from '../schemas/company-email-settings.schema';

/**
 * Saves company email settings
 * @param companyEmailSettings A list of emails and permissions
 * @returns Message indicating success
 */
export function putCompanyEmailSettings(
  this: unknown,
  companyEmailSettings: CompanyEmailSettings
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.companyEmailSettingsUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(companyEmailSettings),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
      })
    )
  );
}
